import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ExclamationMark = (param)=>{
    let { size = 24, testId, style, className } = param;
    const strokeWidth = 1.5 * (24 / size);
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C17.5049 22 22 17.495 22 12C22 6.50495 17.5049 2 12 2C6.49505 2 2 6.49505 2 12C2 17.5049 6.50495 22 12 22Z",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13.55V6.82001",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17.65C12.5523 17.65 13 17.2023 13 16.65C13 16.0977 12.5523 15.65 12 15.65C11.4477 15.65 11 16.0977 11 16.65C11 17.2023 11.4477 17.65 12 17.65Z",
                fill: "currentColor"
            })
        ]
    });
};
